export const AVAILABLE = 'AVAILABLE'
export const UNAVAILABLE = 'UNAVAILABLE'
